import { Component, Vue, Watch } from 'vue-property-decorator';
import { Route } from 'vue-router';

@Component
export default class PageHeader extends Vue {
  public currentUrl: String;
  public pageTitle: String = '';
  public displaySearchSessionsForm: boolean = false;

  /**
   * Watch when URL (route) changes
   * @param newVal
   */
  @Watch('$route', { immediate: true, deep: true })
  onUrlChange(newVal: Route) {
    this.setPage();
  }

  public created() {
    this.getCurrentUrl();
    this.setPage();
  }

  /**
   * Get current URL -> define which page is loaded
   */
  public getCurrentUrl() {
    this.currentUrl = window.location.pathname;
  }

  /**
   * Define which page is loaded based on current URL -> define elements to display in header
   * @param currentUrl current page URL
   */
  public setPage() {
    this.getCurrentUrl();
    this.displaySearchSessionsForm = false;
    this.pageTitle = '';
    switch (this.currentUrl) {
      case '/': {
        this.displaySearchSessionsForm = true;
        break;
      }
      case '/cgu': {
        this.pageTitle = "Conditions Générales d'Utilisation (CGU)";
        break;
      }
      case '/mentions-legales': {
        this.pageTitle = 'Mentions légales';
        break;
      }
      default: {
        break;
      }
    }
  }

  //TODO INCREMENT 2 : A retirer pour l'incrément 2
  /**
   * On click on button "S'inscrire", emit event to inscriptionPage to display the registration form
   */
  public displayRegistrationForm() {
    // @ts-ignore
    this.$eventHub.$emit('displayRegistrationForm');
    this.startScroll();
  }

  //TODO INCREMENT 2 : A retirer pour l'incrément 2
  /**
   * Scroll to inscription form
   */
  public startScroll() {
    let VueScrollTo = require('vue-scrollto');
    let options = {
      container: 'body',
      easing: 'ease',
      offset: 0,
      force: true,
      cancelable: true,
      x: false,
      y: true,
    };
    const element = document.getElementById('inscription');
    // Fix for Internet Explorer : check visibility of div with ID 'inscription' before scrolling to this element
    // If element is not visible yet, set timeout before scrolling down
    if (!this.checkVisibility(element)) {
      window.setTimeout(() => {
        VueScrollTo.scrollTo(element, 500, options);
      }, 500);
    } else {
      VueScrollTo.scrollTo(element, 500, options);
    }
  }

  //TODO INCREMENT 2 : A retirer pour l'incrément 2
  /**
   * Check visibility of element in page
   * @param element
   */
  public checkVisibility(element) {
    let isVisible: boolean;
    if (element.offsetWidth || element.offsetHeight || element.getClientRects().length) {
      isVisible = true;
    } else {
      isVisible = false;
    }
    return isVisible;
  }
}
